import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@mantine/core';

const AppMenu = ({ control, children, ...rest }) => (
  <Menu position="bottom-end" width={190} withinPortal {...rest}>
    <Menu.Target>{control}</Menu.Target>
    <Menu.Dropdown>{children}</Menu.Dropdown>
  </Menu>
);

AppMenu.propTypes = {
  children: PropTypes.any,
  control: PropTypes.any
};

export default AppMenu;
